import { create } from 'zustand';
import { fetchTasks as apiFetchTasks } from '@/api/tasks';
import type { OdooTask, FaseSysteem } from '@/types/odoo';

export function getLocalDateString(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

interface TasksState {
  tasks: OdooTask[];
  installerNames: Record<number, string>;
  projectNames: Record<number, string>;
  werfAddresses: Record<number, string>;
  photoStats: Record<number, { uploaded: number; total: number }>;
  fasePhotoStats: Record<number, { uploaded: number; total: number }>;
  faseSystems: Record<number, FaseSysteem>;
  loading: boolean;
  error: string | null;
  filter: string;
  searchTerm: string;
  selectedDate: string;
  fetchTasks: () => Promise<void>;
  setFilter: (filter: string) => void;
  setSearchTerm: (term: string) => void;
  nextDay: () => void;
  prevDay: () => void;
  goToToday: () => void;
}

export const useTasksStore = create<TasksState>((set, get) => ({
  tasks: [],
  installerNames: {},
  projectNames: {},
  werfAddresses: {},
  photoStats: {},
  fasePhotoStats: {},
  faseSystems: {},
  loading: false,
  error: null,
  filter: 'Alle',
  searchTerm: '',
  selectedDate: getLocalDateString(),

  fetchTasks: async () => {
    set({ loading: true, error: null });
    try {
      const result = await apiFetchTasks(get().selectedDate);
      set({
        tasks: result.tasks,
        installerNames: result.installerNames,
        projectNames: result.projectNames,
        werfAddresses: result.werfAddresses,
        photoStats: result.photoStats ?? {},
        fasePhotoStats: result.fasePhotoStats ?? {},
        faseSystems: result.faseSystems ?? {},
        loading: false,
      });
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Taken ophalen mislukt';
      set({ error: message, loading: false });
    }
  },

  setFilter: (filter) => set({ filter }),
  setSearchTerm: (searchTerm) => set({ searchTerm }),

  nextDay: () => {
    const current = new Date(get().selectedDate + 'T12:00:00');
    current.setDate(current.getDate() + 1);
    set({ selectedDate: getLocalDateString(current), filter: 'Alle' });
  },

  prevDay: () => {
    const current = new Date(get().selectedDate + 'T12:00:00');
    current.setDate(current.getDate() - 1);
    set({ selectedDate: getLocalDateString(current), filter: 'Alle' });
  },

  goToToday: () => {
    set({ selectedDate: getLocalDateString(), filter: 'Alle' });
  },
}));
